/**
 * Beyond Card Types Slugs enums based on Docecbo learning types or Beyond course offerings
 */
export enum CardTypeSlugs {
  FLEXIBLE_METHODS_OF_LEARNING = 'flexible_learning',
  LEARNING_PLAN = 'learning_plan',
  SUBSCRIPTION = 'Subscription',
  UPCOMING_SESSION = 'upcoming_session',
}
